// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bot-detail {\n  font-weight: bold;\n  font-size: 14px;\n}\n.bot-detail textarea {\n  resize: none;\n}", "",{"version":3,"sources":["webpack://src/components/MercurXBotDetailInputs/MercurXBotDetailInputs.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,eAAA;AACJ;AACI;EACI,YAAA;AACR","sourcesContent":[".bot-detail {\n    font-weight: bold;\n    font-size: 14px;\n\n    textarea {\n        resize: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
